export { default } from './Message'

const systemMessagesTypes = [
	'BUBBLE_CREATED',
	'BUBBLE_JOIN',
	'BUBBLE_LEAVE',
	'BUBBLE_KICKED',
	'TITLE_UPDATE',
	'DROPIN_INVITED',
	'DM_CREATED',
	'TASK_ASSIGNED',
	'TASK_REASSIGNED',
	'TASK_DUEDATECHANGED',
	'TASK_CLAIMED',
	'TASK_COMPLETED',
	'TASK_UNCOMPLETED',
	'TASK_DELETED',
	'BUBBLE_ADDED_MANY',
	'VIDEOSESSION_STARTED',
]

export const isStyledSystemMessage = (message) =>
	systemMessagesTypes.includes(message.systemevent)
